import { PageSubTitle, PageTitle } from "@/components/pageTitle";

export const Advantages = () => {
  return (
    <div className="flex justify-center">
      <div className="pt-[77px] px-[240px] pb-[100px] w-[1920px]">
        <PageTitle title="我们的优势" />
        <PageSubTitle title="根据企业需求，为企业构建高性价比的专属全场景网络连接方案" />
        <div className="flex gap-[40px] justify-between mt-[80px]">
          <Item
            img="/imgs/saas/全球节点.png"
            title="全球节点"
            content="光年自研K-WAN加速引擎在全球部署节点组建专用骨干网络，为企业提供、安全、合规、稳定的全球互联网服务"
          />
          <Item
            img="/imgs/saas/成员轻松管理.png"
            title="成员轻松管理"
            content="提供企业后台管理系统，可以根据公司架构针对部门分类管理，线路调度分配、IP定制化服务，自定义设置访问IP黑白名单功能等。"
          />
        </div>
        <div className="flex gap-[40px] justify-between mt-[40px]">
          <Item
            img="/imgs/saas/更快更优.png"
            title="应用体验更快更优"
            content="可远距离定向加速SAAS应用程序网络体验更快更优，在移动设备上开启配套应用程序，可通过SD-WAN设备内置服务器访问海外服务。"
          />
          <Item
            img="/imgs/saas/智能分流.png"
            title="智能分流"
            content="支持自动分流，访问国内网站使用本地宽带，仅访问海外网站使用国际专线。"
          />
        </div>
        <div className="flex gap-[40px] justify-between mt-[40px]">
          <Item
            img="/imgs/saas/节省成本.png"
            title="节省成本"
            content="使用光年无界全球节点网络，可大幅降低企业专线带宽采购成本，适合大中小企业。"
          />
          <Item
            img="/imgs/saas/快速部署.png"
            title="快速部署"
            content="提供CPE路由器即插即用。设备在数分钟内即可接入国际网络。并且适配PC\MAC\安卓\IOS\浏览器插件等多平台开启配套应用程序，通过设备内置服务器访问海外服务。"
          />
        </div>
        <div className="mt-[60px]" />
        <PageTitle title="除此之外，我们相当重视合法合规与服务" />
        <PageSubTitle title="根据企业需求，为企业构建高性价比的专属全场景网络连接方案" />
        <div className="flex gap-[40px] justify-between mt-[40px]">
          <Item
            img="/imgs/saas/合规合法.png"
            title="线路合法合规"
            content="使用符合国家政策的三大运营商跨境专线与大厂服务商，符合各地政策要求，仅提供合规出海网络访问服务。"
          />
          <Item
            img="/imgs/saas/24.png"
            title="7*24H服务"
            content="拥有完整的线上线下售前售后体系，随时在线为您提供专业的技术与服务支持。"
          />
        </div>
      </div>
    </div>
  );
};

export const Item = (props: {
  img?: string;
  title: string;
  content: string;
}) => {
  return (
    <div className="w-[700px] h-[180px] bg-gradient-to-r from-[#EDF9FC] via-[#F1F9FD] to-[#F5F8FF] rounded-[10px] p-[40px] flex items-center">
      <img
        className="w-[100px] min-w-[100px] h-[100px] bg-[#3B77FD] rounded-[12px] mr-[20px]"
        src={props.img}
      />
      <div>
        <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-normal text-[25px] text-[#000000]">
          {props.title}
        </div>
        <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-normal text-[16px] text-[#333333]">
          {props.content}
        </div>
      </div>
    </div>
  );
};
